import React, { PureComponent, Children } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';

import ScrollToTopOnMount from 'cityads-v3/containers/misc/ScrollToTopOnMount';

import classes from './Page.scss';

export default class Page extends PureComponent {
  static propTypes = {
    title          : PropTypes.string,
    subTitle       : PropTypes.string,
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    pageTitle      : PropTypes.string,
    pageDescription: PropTypes.string,
    pageKeywords   : PropTypes.string,
  }

  render() {
    const { className, title, subTitle, backgroundColor, backgroundImage, children, pageTitle, pageDescription, pageKeywords } = this.props;

    return (
      <article className={classNames(className, classes.article)}>
        <ScrollToTopOnMount/>

        {(pageTitle || pageDescription || pageKeywords) ?
          (
            <Helmet
              title = {pageTitle}
              meta  = {[
                ...(pageDescription ? [{ name: 'description', content: pageDescription }] : []),
                ...(pageKeywords ? [{ name: 'keywords', content: pageKeywords }] : []),
              ]}
            />
          ) :
          null
        }

        <div className={classes.header}>
          <div className={classes.banner} style={{ backgroundColor, backgroundImage: `url(${backgroundImage})` }}>
          </div>

          <div className={classes.titleContainer}>
            <h1 className={classes.title}>{title}</h1>
            <div className={classes.subTitle}>{subTitle}</div>
          </div>
        </div>

        <div className={classes.content}>

          {Children.map(children, (child, index) => {
            if (!child) return null;

            if ( child.props && child.props['data-as-is'] ) return child;

            return (
              <div key={index} className={classes.text}>
                {child}
              </div>
            )
          })}
        </div>
      </article>
    );
  }
}
